export default "__VITE_ASSET__DxRdKpc0__"